import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'

// COMPONENTS
import { Typography, Button, Column, Container, TextInput } from 'components'
import { Trans } from '@lingui/macro'
import Logo from '../../components/Logo'
import Row from '../../components/Row'
import NotificationStep from '../../components/NotificationStep'

import axios from '../../settings/axios'
import InputValidation from '../../utils/InputValidation'
import { PASSWORD_NOT_EQUAL } from '../../utils/ValidationErrorList'
import * as routes from './../../settings/_routesSettings'
import { apiEndpoints } from '../../settings/_apiSettings'
import Toast from '../../components/Toast'


class ResetPassword extends Component {
  state = {
    password: '',
    isValid: false,
    passwordIsValid: false,
    passwordMsg: '',
    passwordsMatch: true,
    retypePassword: '',
    retypePasswordMsg: PASSWORD_NOT_EQUAL,
    showPassword: false,
    isSuccess: false,
    msgError: '',
  }

  handleShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }))
  }

  handleButtonClick = () => {
    this.props.history.push(routes.LOGIN)
  }

  onPasswordChange = e => {
    let passwordValue = e.target.value
    let validation = new InputValidation(passwordValue, 'password').validate()

    this.setState({
      password: passwordValue,
      passwordMsg: validation.message,
      passwordIsValid: validation.success,
    })
  }

  onPasswordConfirm = e => {
    let inputValue = e.target.value

    if (this.state.password === inputValue) {
      this.setState({
        isValid: true,
        passwordsMatch: true,
        retypePassword: inputValue,
      })
    } else {
      this.setState({
        isValid: false,
        passwordsMatch: false,
        retypePassword: inputValue,
      })
    }
  }

  resetPasswordSubmit = (e) => {
    e.preventDefault()

    const query = queryString.parse(this.props.location.search)
    const postData = { password: this.state.password }

    axios.get(`${apiEndpoints.ACCOUNTS}${query.slug}/password/${query.key}/`)
      .then(response => {
        if (response.status === 'OK') {
          axios.put(`${apiEndpoints.ACCOUNTS}${query.slug}/password/${query.key}/`, postData)
            .then(response => {
              this.setState({ isSuccess: true, msgError: '' })
            }).catch(err => {
              if (err.response.status === 403){
                this.setState({msgError: 'Token expirado ou já utilizado.'})
              }
            })
        }
      })
      .catch(err => {
        if (err.response.status === 404){
          this.setState({msgError: 'Token não encontrado.'})
        }
      })
  }

  render() {
    const { password, passwordIsValid, passwordMsg, passwordsMatch, retypePassword, retypePasswordMsg, showPassword, isSuccess } = this.state
    const typeText = 'text'
    const typePassword = 'password'
    return (
      <Fragment >
        {
          this.state.msgError !== '' && (
            <Row margin="1.5rem 0"
              justify='center'>
              <Column colWidth={5}>
                <Toast variant="error"
                  message={this.state.msgError}
                />
              </Column>
            </Row>
          )
        }

        {
          /*
           * When completed all steps, renders NotificationStep component.
           * Otherwise, renders Steps components.
          */
          isSuccess ? (
            <Row justify="center">
              <NotificationStep
                btnText={<Trans>Começar!</Trans>}
                iconColor="#55d86b"
                iconName='Check'
                mainText={
                  <Typography align="center" Tag="h1" type="title">
                    <Trans>
                      Senha cadastrada com sucesso!
                    </Trans>
                  </Typography>}
                onSuccessClick={this.handleButtonClick}
              />
            </Row>
          ) : (
            <Fragment>
              <Container isView>
                <Row justify='center' margin='6.2rem 0 3.0rem'>
                  <Column align='center' justify='center' colWidth={4}>
                    <Column colWidth={3}>
                      <Logo 
                        onClickLogo={() => window.location.href = process.env.REACT_APP_INSTITUTIONAL_URL}
                      />
                    </Column>
                  </Column>
                </Row>
                <Row justify="center">
                  <Column colWidth={4}>
                    <Typography type="title" Tag="h1" gutterBotton>
                      <Trans>
                          Redefinir Senha
                      </Trans>
                    </Typography>
                  </Column>
                </Row>
                <Row justify="center">
                  <Column colWidth={4}>
                    <Typography type="paragraph" Tag="p" gutterBotton>
                      <Trans>
                          Insira uma nova senha abaixo. Ela deve possuir no mínimo 6 caracteres:
                      </Trans>
                    </Typography>
                  </Column>
                </Row>
                <Row justify="center">
                  <Column colWidth={4}>
                    <form>
                      <TextInput
                        autofocus={true}
                        handleShowPassword={() => this.handleShowPassword()}
                        hasError={passwordMsg}
                        isPassword={true}
                        messageError={passwordIsValid ? '' : passwordMsg}
                        name="password"
                        onInputChange={this.onPasswordChange}
                        placeholder="Senha"
                        required={true}
                        showPassword={showPassword}
                        type={showPassword ? typeText : typePassword}
                        value={password}
                      />
                      <TextInput
                        hasError={!passwordsMatch}
                        name="retypePassword"
                        messageError={passwordsMatch ? '' : retypePasswordMsg}
                        onInputChange={this.onPasswordConfirm}
                        placeholder="Confirmação de senha"
                        type={typePassword}
                        required={true}
                        value={retypePassword}
                      />
                      <Row margin="2.5rem 0">
                        <Button id='reset-password' text={(<Trans>Redefinir Senha</Trans>)}
                          type="submit"
                          onButtonClick={this.resetPasswordSubmit}
                          disabled={!this.state.isValid}
                        />
                      </Row>
                    </form>
                  </Column>
                </Row>
              </Container>
            </Fragment>
          )
        }
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return { state: state }
}
function actionFunction() { }
const mapDispatchToProps = dispatch => {
  return { onAction: (variable) => dispatch(actionFunction(variable)) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)